<template>
  <nav class="navbar navbar-light navbar-expand-lg">
    <div class="navbar-brand">
      <nav>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            {{ pageTitle }}
          </li>
        </ol>
      </nav>
    </div>
    <li
      class="navbar-toggler b-nav-dropdown dropdown user-profile"
      :style="{'margin-right': `${paddingLeft}px`}"
    >
      <div
        class="wrapper"
        v-click-outside="() => {isTogglerOpen = false}"
      >
        <button @click="openToggler">
          <span class="navbar-toggler-icon" />
        </button>
        <ul
          class="dropdown-menu dropdown-menu-right"
          :class="{'show': isTogglerOpen}"
        >
          <li class="dropdown-item">
            <img
              v-if="picture"
              class="rounded-circle user-icon"
              :src="picture"
              data-holder-rendered="true"
            >
            <div
              v-else
              class="vue-avatar--wrapper d-inline-block user-icon-character"
            >
              {{ userNameUpper }}
            </div>
            {{ name }}
          </li>
          <li class="dropdown-item">
            <span class="dropdown-label">
              <div style="font-size:.875rem; font-weight:600; color:#94A4AE">{{ userRole }}</div>
              <div style="font-size:1rem; font-weight:700;">{{ email }}</div>
            </span>
          </li>
          <li
            class="dropdown-item"
            @click="logout"
          >
            <i class="fas fa-sign-out-alt">
              {{ $t('LOGIN.Logout') }}
            </i>
          </li>
        </ul>
      </div>
    </li>

    <div
      id="nav-collapse"
      class="navbar-collapse collapse"
      style="display: none;"
    >
      <ul
        class="navbar-nav ml-auto d-flex align-items-center"
        :style="{'margin-right': `${paddingLeft}px`}"
      >
        <!-- NOTE: Help (Intercom) button -->
        <li class="nav-item">
          <a @click="toHelpPage">
            <span class="nav-icon nav-icon-faq">
              <i class="ab-icon ab-icon-xl ab-icon-faq" />
            </span>
          </a>
        </li>

        <div class="nav-divider" />

        <span class="navbar-text">
          <span class="p-2">
            {{ customerName }}
          </span>
        </span>

        <div class="nav-divider" />

        <li class="nav-item b-nav-dropdown dropdown user-profile">
          <div
            class="wrapper"
            v-click-outside="() => {isOpen = false}"
          >
            <button @click="openAuth">
              <img
                v-if="picture"
                class="rounded-circle user-icon"
                :src="picture"
                data-holder-rendered="true"
              >
              <div
                v-else
                class="vue-avatar--wrapper d-inline-block user-icon-character"
              >
                {{ userNameUpper }}
              </div>
              {{ name }}
            </button>
            <ul
              class="dropdown-menu dropdown-menu-right"
              :class="{'show': isOpen}"
            >
              <li class="dropdown-item">
                <span class="dropdown-label">
                  <div style="font-size:.875rem; font-weight:600; color:#94A4AE">{{ userRole }}</div>
                  <div style="font-size:1rem; font-weight:700;">{{ email }}</div>
                </span>
              </li>
              <li
                class="dropdown-item"
                @click="logout"
              >
                <i class="fas fa-sign-out-alt">
                  {{ $t('LOGIN.Logout') }}
                </i>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import * as axios from 'axios'
import { MS_API_PARAMS } from '@/config/constants'
import { mapState, mapActions } from 'vuex'

const TitleTable = {
  SmartScheduling: 'SmartScheduling',
  Setting: 'Setting',
  AbejaAdmin: 'AdminManagement',
  Status: 'Status'
}

export default {
  name: "HeaderBar",
  props: {
    paddingLeft: {
      type: Number,
      default: 64
    }
  },
  data: () => ({
    backendUri: MS_API_PARAMS.backendUri,
    isOpen: false,
    isTogglerOpen: false
  }),
  computed: {
    ...mapState([
      'lang'
    ]),
    ...mapState('auth', [
      'name',
      'picture',
      'email',
      'customerName',
      'role'
      // 'uid'
    ]),
    userNameUpper () {
      if (!this.email) return '!'
      const result = this.email.slice(0, 1).toUpperCase()
      return result
    },
    userRole() {
      const roleTable = {
        admin: this.$t('General.Admin'),
        owner: this.$t('General.Owner'),
        user: this.$t('General.Member'),
      }
      return roleTable[this.role]
    },
    pageTitle() {
      return this.$t(`${TitleTable[this.$route.name]}.Title`)
    }
  },
  methods: {
    ...mapActions('auth', [
      'signOut'
    ]),
    toHelpPage() {
      open('https://intercom.help/abeja-agently', '_blank');
    },
    openAuth () {
      this.isOpen = !this.isOpen
    },
    openToggler () {
      this.isTogglerOpen = !this.isTogglerOpen
    },
    logout () {
      this.signOut().then(() => {
        if (this.$route.path !== `/login/${this.lang}`) {
          this.$router.push({
            name: 'Login',
            params: {
              lang: this.lang
            }
          })
        }
      }).catch((err) => {
        console.error(err)
        return Promise.reject(err)
      })
      // TODO: ここ書く
    }
  }
}
</script>

<style lang="scss" scoped>
.user-icon {
  width: 40px;
  height: 40px;
}
.user-icon-character {
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font: 16px / 40px Helvetica, Arial, sans-serif;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: rgb(144, 160, 183);
  color: rgb(255, 255, 255);
  background-image: url("/img/default-user-avatar.d44d9d5c.png");
  background-size: 40px 40px;
  background-position: left top;
}
</style>
